import React from "react";
import { BWHeader, space3, space6 } from "../dist/helpers";

export const SpecialImage = (image) => (
  <div
    style={{
      display: "inline",
      paddingBottom: "5px",
      paddingRight: "5px"
    }}
  >
    <a href={ image }>
      <img src={ image } alt="logo"
        style={{
          maxWidth: "25%",
          minWidth: "10%",
          border: "5px solid #1111",
          backgroundColor: "white",
        }}
      />
    </a>
  </div>
)


let takePart = (image, part1, part2, multiplier=1) => {
  let width = multiplier * 256 - (multiplier *  64 * 3)
  let margin = multiplier *  64 * part1
  let margin2 = multiplier *  64 * part2
  return (
    <>
      <div
        style={{
          width: `${ width }px`,
          height: `${ width }px`,
          overflow: "hidden",
          display: "inline-block",
        }}
      >
        <img
          alt="spriteFrame1"
          src={image}
          style={{
            margin: `-${ margin }px 0px 0px -${ margin2 }px`,
          }}
        />
      </div>
    </>
  );
}

export const SpriteFourStep = (frame, image, offset = 0, offset2 = 0, multiplier=1) => {
  if (frame === 0) {
    return takePart(image, 0 + offset2, 0 + offset, multiplier)
  } else if (frame === 1) {
    return takePart(image, 0 + offset2, 1 + offset, multiplier)
  } else if (frame === 2) {
    return takePart(image, 0 + offset2, 2 + offset, multiplier)
  } else if (frame === 3) {
    return takePart(image, 0 + offset2, 3 + offset, multiplier)
  }
}

export const SpriteTwoStep = (frame, image, offset = 0, offset2 = 0, multiplier=1) => {
  if (frame > 0) {
    return takePart(image, 0 + offset2, 0 + offset, multiplier)
  } else {
    return takePart(image, 0 + offset2, 1 + offset, multiplier)
  }
}

export default function Experimental(props) {
  const { finalIsDarkMode } = props;

  return (
    <div>
      {space3}
      <center>
        { BWHeader(finalIsDarkMode, "Experimental", "This is the work in progress kinda stuff") }
        { space6 }
        { space6 }

      </center>
    </div>
  )
};
